<template>
	<a-modal
		class="g-video-list-edit-modal"
		:visible="visible"
		title="模块编辑"
		width="730px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
		<div class="g-video-list-edit" @click="clearSelection">
			<div class="g-video-list-edit__actions" @click.stop>
				<span v-if="form.items.length > 1" class="g-video-list-edit__hint">视频支持拖拽排序</span>
				<div class="g-video-list-edit__actions-btns">
					<button type="button" class="g-video-list-edit__batch-btn" @click="addBatch">添加一批</button>
					<button type="button" class="g-video-list-edit__batch-btn" @click="addOne">添加一格</button>
				</div>
			</div>

			<div
				class="g-video-list-edit__card"
				:class="{ 'is-card': form.showCard }"
				:style="previewCardStyle"
			>
			<EditListSortGroup
				ref="editGrid"
				class="g-video-list-edit__grid"
				@dragover="onSortDragOver"
			>
				<div
					v-for="(item, index) in form.items"
					:key="item.id"
					:data-sort-id="item.id"
					class="g-video-list-edit__cell-wrap"
					:class="[{ 'is-active': selectedIndex === index }, getEditListSortItemClass(dragId, item.id, dragOverId)]"
					@click.stop
				>
						<div
							class="g-video-list-edit__cell"
							:class="{ 'is-selected': selectedIndex === index }"
							:draggable="form.items.length > 1"
							@click="selectItem(index)"
							@dragstart="onItemDragStart(item.id)"
							@dragend="onItemDragEnd"
						>
							<div
								class="g-video-list-edit__thumb"
								:style="previewThumbStyle"
							>
								<UploadProgressPanel
									v-if="isUploading && selectedIndex === index"
									:tasks="uploadTasks"
									variant="item"
									hide-filename
								/>
								<template v-else>
									<img v-if="getCoverUrl(item)" :src="getCoverUrl(item)" alt="" />
									<i v-else class="mbm-iconfont mbm-shipin"></i>
									<button
										type="button"
										class="g-video-list-edit__play"
										aria-label="播放"
										@click.stop="playEditMedia(getVideoUrl(item), 'video')"
									>
										<span class="g-video-list-edit__triangle"></span>
									</button>
									<span class="g-video-list-edit__duration">{{ item.video?.durationText || '00:00' }}</span>
								</template>
							</div>
							<input
								v-model="item.title"
								type="text"
								class="g-video-list-edit__title-input"
								:style="{ color: item.titleColor }"
								maxlength="40"
								placeholder="标题"
								@click.stop="selectItem(index)"
								@focus="selectItem(index)"
							/>
							<input
								v-model="item.description"
								type="text"
								class="g-video-list-edit__desc-input"
								:style="{ color: item.descColor }"
								maxlength="40"
								placeholder="描述"
								@click.stop="selectItem(index)"
								@focus="selectItem(index)"
							/>
						</div>

						<div
							v-if="selectedIndex === index"
							class="g-video-list-edit__panel g-video-list-edit__panel--arrow g-video-list-edit__panel--float"
							:class="getPanelAlignClass(index)"
							@click.stop
						>
							<div class="g-video-list-edit__toolbar">
								<button type="button" class="g-video-list-edit__action" @click="triggerVideoSelect">更换视频</button>
								<button type="button" class="g-video-list-edit__action" @click="triggerCoverSelect">更换封面</button>
								<button
									type="button"
									class="g-video-list-edit__action"
									:class="{ 'is-active': !form.showCard }"
									@click="toggleShowCard"
								>{{ form.showCard ? '隐藏卡片' : '显示卡片' }}</button>
								<button
									v-if="form.showCard"
									type="button"
									class="g-video-list-edit__action"
									:class="{ 'is-active': activePanel === 'cardRadius' }"
									@click="togglePanel('cardRadius')"
								>卡片圆角</button>
								<button
									type="button"
									class="g-video-list-edit__action"
									:class="{ 'is-active': activePanel === 'videoRadius' }"
									@click="togglePanel('videoRadius')"
								>视频圆角</button>
								<button
									type="button"
									class="g-video-list-edit__action"
									:class="{ 'is-active': activePanel === 'height' }"
									@click="togglePanel('height')"
								>高度</button>
								<button
									type="button"
									class="g-video-list-edit__action g-video-list-edit__action--danger-text"
									:disabled="form.items.length <= 1"
									@click="deleteItem(index)"
								>删除</button>
								<div class="g-video-list-edit__colors">
									<ColorPicker
										v-model="selectedItem.titleColor"
										title="标题颜色"
										@change="onTitleColorInput"
									/>
									<ColorPicker
										v-model="selectedItem.descColor"
										title="描述颜色"
										@change="onDescColorInput"
									/>
								</div>
							</div>
							<div v-if="activePanel === 'height'" class="g-video-list-edit__sub-row">
								<span class="g-video-list-edit__sub-label">高度 (px)</span>
								<a-input-number
									v-model:value="heightDraft"
									:min="1"
									:max="800"
									:precision="0"
									class="g-video-list-edit__sub-input"
								/>
								<button type="button" class="g-video-list-edit__sub-confirm" @click="applyHeight">确定</button>
								<span class="g-video-list-edit__sub-default">默认值:{{ defaultHeight }}</span>
							</div>
							<div v-if="activePanel === 'cardRadius'" class="g-video-list-edit__sub-row">
								<span class="g-video-list-edit__sub-label">卡片圆角 (px)</span>
								<a-input-number
									v-model:value="cardRadiusDraft"
									:min="0"
									:max="100"
									:precision="0"
									class="g-video-list-edit__sub-input"
								/>
								<button type="button" class="g-video-list-edit__sub-confirm" @click="applyCardRadius">确定</button>
							</div>
							<div v-if="activePanel === 'videoRadius'" class="g-video-list-edit__sub-row">
								<span class="g-video-list-edit__sub-label">视频圆角 (px)</span>
								<a-input-number
									v-model:value="videoRadiusDraft"
									:min="0"
									:max="100"
									:precision="0"
									class="g-video-list-edit__sub-input"
								/>
								<button type="button" class="g-video-list-edit__sub-confirm" @click="applyVideoRadius">确定</button>
							</div>
						</div>
					</div>
				</EditListSortGroup>
			</div>
		</div>
		</div>

		<input
			ref="coverInput"
			type="file"
			accept="image/*"
			class="g-video-list-edit__file-input"
			@change="onCoverSelect"
		/>
		<input
			ref="videoInput"
			type="file"
			accept="video/*,.mp4,.mov,.avi,.flv,.mkv,.webm,.m4v,.wmv"
			class="g-video-list-edit__file-input"
			@change="onVideoSelect"
		/>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" class="g-video-list-edit-modal__ok" :disabled="isUploading" @click="onConfirm">确定</a-button>
		</template>

		<EditMediaPlayerOverlay
			:url="editPlayingUrl"
			:kind="editPlayingKind"
			@close="stopEditMediaPlay"
		/>
	</a-modal>
</template>

<script>
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import ColorPicker from './ColorPicker.vue';
	import {
		isLocalImageFile,
		MAX_LOCAL_IMAGE_SIZE,
	} from '../utils/localImage.js';
	import {
		filterValidLocalVideoList,
		isVideoFilename,
		MAX_LOCAL_VIDEO_SIZE,
	} from '../utils/localVideo.js';
	import {
		createDefaultVideoListItem,
		createDefaultVideoListItems,
		getVideoListCoverUrl,
		getVideoListThumbAspectRatio,
		getVideoListVideoUrl,
		normalizeVideoListData,
		replaceVideoListCover,
		replaceVideoListVideo,
		revokeVideoListItems,
		VIDEO_LIST_DEFAULT_CARD_RADIUS,
		VIDEO_LIST_DEFAULT_HEIGHT,
		VIDEO_LIST_DEFAULT_VIDEO_RADIUS,
		VIDEO_LIST_CARD_PADDING,
	} from '../utils/videoList.js';
	import { ensureEditFloatPanelVisible, getGridPanelAlignClass } from '../utils/editPanelAlign.js';
	import editModalMediaPlay from '../mixins/editModalMediaPlay.js';
	import EditListSortGroup from './EditListSortGroup.vue';
	import EditMediaPlayerOverlay from './EditMediaPlayerOverlay.vue';
	import {
		createEditListDragState,
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
		resolveSelectedIndexAfterListMove,
	} from '../utils/editListDragSort.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GVideoListEditModal',
		components: { EditListSortGroup, EditMediaPlayerOverlay, UploadProgressPanel, ColorPicker },
		mixins: [editModalMediaPlay],
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: normalizeVideoListData({}),
				selectedIndex: null,
				activePanel: '',
				heightDraft: VIDEO_LIST_DEFAULT_HEIGHT,
				cardRadiusDraft: VIDEO_LIST_DEFAULT_CARD_RADIUS,
				videoRadiusDraft: VIDEO_LIST_DEFAULT_VIDEO_RADIUS,
				defaultHeight: VIDEO_LIST_DEFAULT_HEIGHT,
				isUploading: false,
				uploadTasks: [],
				...createEditListDragState(),
			};
		},
		computed: {
			selectedItem() {
				return this.form.items[this.selectedIndex] || null;
			},
			previewThumbStyle() {
				return {
					aspectRatio: getVideoListThumbAspectRatio(this.form.imageHeight),
					borderRadius: `${this.form.videoBorderRadius}px`,
				};
			},
			previewCardStyle() {
				if (!this.form.showCard) {
					return {};
				}
				return {
					borderRadius: `${this.form.cardBorderRadius}px`,
					padding: `${VIDEO_LIST_CARD_PADDING}px`,
				};
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = null;
					this.activePanel = '';
					this.syncForm();
				}
			},
			data: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			getEditListSortItemClass,
			getPanelAlignClass(index) {
				return getGridPanelAlignClass(index, 2);
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					wrapSelector: '.g-video-list-edit__cell-wrap',
					panelSelector: '.g-video-list-edit__panel--float',
				});
			},
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getCoverUrl(item) {
				return getVideoListCoverUrl(item);
			},
			getVideoUrl(item) {
				return getVideoListVideoUrl(item);
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			syncForm() {
				this.form = normalizeVideoListData(this.data);
				this.heightDraft = this.form.imageHeight;
				this.cardRadiusDraft = this.form.cardBorderRadius;
				this.videoRadiusDraft = this.form.videoBorderRadius;
				if (
					this.selectedIndex != null
					&& this.selectedIndex >= this.form.items.length
				) {
					this.selectedIndex = null;
				}
			},
			selectItem(index) {
				this.selectedIndex = index;
				this.ensureActivePanelVisible();
			},
			clearSelection() {
				this.selectedIndex = null;
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.heightDraft = this.form.imageHeight;
				}
				if (panel === 'cardRadius') {
					this.cardRadiusDraft = this.form.cardBorderRadius;
				}
				if (panel === 'videoRadius') {
					this.videoRadiusDraft = this.form.videoBorderRadius;
				}
				if (this.activePanel) {
					this.ensureActivePanelVisible();
				}
			},
			toggleShowCard() {
				this.form.showCard = !this.form.showCard;
				if (!this.form.showCard && this.activePanel === 'cardRadius') {
					this.activePanel = '';
				}
			},
			addBatch() {
				this.form.items.push(...createDefaultVideoListItems(4));
				this.selectedIndex = this.form.items.length - 4;
			},
			addOne() {
				this.form.items.push(createDefaultVideoListItem({}, this.form.items.length));
				this.selectedIndex = this.form.items.length - 1;
			},
			onItemDragStart(id) {
				handleEditListSortDragStart(this, id);
			},
			onSortDragOver(event) {
				handleEditListSortDragOver(event, this.$refs.editGrid, this);
			},
			onItemDragEnd() {
				handleEditListSortDragEnd(this, this.$refs.editGrid, this.form.items, this, (result) => {
					this.selectedIndex = resolveSelectedIndexAfterListMove(
						this.selectedIndex,
						result.fromIndex,
						result.toIndex,
					);
				});
			},
			deleteItem(index) {
				if (this.form.items.length <= 1) return;
				const removed = this.form.items[index];
				if (removed) {
					revokeVideoListItems([removed]);
				}
				this.form.items.splice(index, 1);
				if (this.selectedIndex === index) {
					this.selectedIndex = null;
					this.activePanel = '';
				} else if (this.selectedIndex != null && this.selectedIndex > index) {
					this.selectedIndex -= 1;
				}
			},
			triggerCoverSelect() {
				this.$refs.coverInput?.click();
			},
			triggerVideoSelect() {
				this.$refs.videoInput?.click();
			},
			async onCoverSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !isLocalImageFile(file) || !this.selectedItem) return;
				if (file.size > MAX_LOCAL_IMAGE_SIZE) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					this.selectedItem.cover = replaceVideoListCover(
						this.selectedItem.cover,
						file,
						() => item,
					);
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			async onVideoSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !this.selectedItem) return;
				if (!file.type?.startsWith('video/') && !isVideoFilename(file.name)) return;
				if (file.size > MAX_LOCAL_VIDEO_SIZE) return;
				const [validFile] = filterValidLocalVideoList([file], 1);
				if (!validFile) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([validFile]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'video',
						files: [validFile],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					this.selectedItem.video = replaceVideoListVideo(this.selectedItem.video, item);
					this.selectedItem.cover = { id: '', filename: '', previewUrl: '', url: '', local: false };
				} catch (error) {

					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onTitleColorInput(color) {
				if (!this.selectedItem) return;
				this.selectedItem.titleColor = color;
			},
			onDescColorInput(color) {
				if (!this.selectedItem) return;
				this.selectedItem.descColor = color;
			},
			applyHeight() {
				this.form.imageHeight = Math.max(1, Number(this.heightDraft) || VIDEO_LIST_DEFAULT_HEIGHT);
				this.activePanel = '';
			},
			applyCardRadius() {
				this.form.cardBorderRadius = Math.max(0, Number(this.cardRadiusDraft) || 0);
				this.activePanel = '';
			},
			applyVideoRadius() {
				this.form.videoBorderRadius = Math.max(0, Number(this.videoRadiusDraft) || 0);
				this.activePanel = '';
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const payload = normalizeVideoListData({ ...this.form });
				this.$emit('confirm', payload);
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.edit-float-panel(g-video-list-edit__panel);
	.edit-float-toolbar(g-video-list-edit__toolbar);
	.edit-float-action(g-video-list-edit__action);

	.g-video-list-edit {
		min-height: 360px;
		padding: 4px 0 12px;
	}

	.g-video-list-edit__actions {
		.edit-list-sort-actions-row();
		margin-bottom: 16px;
	}

	.g-video-list-edit__actions-btns {
		.edit-list-sort-actions-btns();
	}

	.g-video-list-edit__batch-btn {
		border: none;
		background: transparent;
		padding: 0;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;

		&:hover {
			color: #1d4ed8;
		}
	}

	.g-video-list-edit__card {
		box-sizing: border-box;
		width: 100%;

		&.is-card {
			background: #fff;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		}
	}

	.g-video-list-edit__card,
	.g-video-list-edit__grid {
		overflow: visible;
	}

	.g-video-list-edit__grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		width: 100%;
		box-sizing: border-box; 
	}

	.g-video-list-edit__cell-wrap {
		position: relative;
		z-index: 0;
		overflow: visible;

		&.is-active {
			z-index: 2;
		}
	}

	.g-video-list-edit__hint {
		.edit-list-sort-hint-text();
	}

	.g-video-list-edit__cell {
		box-sizing: border-box;
		border: 2px dashed #fff;
		border-radius: 2px;
		cursor: grab;

		&:active {
			cursor: grabbing;
		}

		&.is-selected {
			border-color: #285af9;
		}
	}

	.g-video-list-edit__thumb {
		position: relative;
		width: 100%;
		height: auto;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 24px;
			color: #bfbfbf;
		}
	}

	.g-video-list-edit__play {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		margin: -18px 0 0 -18px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.45);
		cursor: pointer;
	}

	.g-video-list-edit__triangle {
		display: block;
		width: 0;
		height: 0;
		margin-left: 3px;
		border-top: 6px solid transparent;
		border-bottom: 6px solid transparent;
		border-left: 10px solid #fff;
	}

	.g-video-list-edit__duration {
		position: absolute;
		left: 8px;
		bottom: 8px;
		z-index: 2;
		padding: 2px 6px;
		border-radius: 4px;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		font-size: 11px;
		line-height: 1.4;
		pointer-events: none;
	}

	.g-video-list-edit__title-input,
	.g-video-list-edit__desc-input {
		display: block;
		width: 100%;
		border: none;
		background: transparent;
		outline: none;
		padding: 0;
		box-sizing: border-box;
	}

	.g-video-list-edit__title-input {
		margin-top: 8px;
		font-size: 14px;
		font-weight: 600;
		line-height: 1.4;
	}

	.g-video-list-edit__desc-input {
		margin-top: 4px;
		font-size: 12px;
		line-height: 1.5;
	}

	.g-video-list-edit__colors {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-left: 4px;
		flex-shrink: 0;
	}

	.g-video-list-edit__swatch {
		position: relative;
		width: 18px;
		height: 18px;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		cursor: pointer;
		flex-shrink: 0;
		overflow: hidden;
	}

	.g-video-list-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		border: none;
		padding: 0;
	}

	.g-video-list-edit__sub-row {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 8px;
		padding: 8px 12px 10px;
		border-top: 1px solid #f0f0f0;
		white-space: nowrap;
	}

	.g-video-list-edit__sub-label {
		font-size: 13px;
		color: #666;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-video-list-edit__sub-input {
		width: 88px;
		flex-shrink: 0;
	}

	.g-video-list-edit__sub-confirm {
		flex-shrink: 0;
		height: 28px;
		padding: 0 12px;
		border: none;
		border-radius: 4px;
		background: #285af9;
		color: #fff;
		font-size: 12px;
		line-height: 28px;
		white-space: nowrap;
		cursor: pointer;

		&:hover {
			background: #3868ff;
		}
	}

	.g-video-list-edit__sub-default {
		font-size: 12px;
		color: #999;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-video-list-edit__file-input {
		display: none;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-video-list-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();

		.g-video-list-edit-modal__ok {
			white-space: nowrap;
			flex-shrink: 0;

			&:hover,
			&:focus {
				background: #3868ff;
				border-color: #3868ff;
			}
		}
	}
</style>
